import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

// Tarjeta compacta de Velora (radio 6, sombra suave, padding 16): ocupa la celda de la rejilla de
// la página en lugar de los 450 x 225 px fijos de antes
const CardEvaluativeTestsStyled = styled.div`
  min-width: 0;

  .card-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
    height: 100%;
    padding: 16px;
    background: ${tokens.color.background.default};
    border-radius: 6px;
    box-shadow: 0 4px 6px rgba(98, 102, 113, 0.06), 0 2px 2px rgba(98, 102, 113, 0.06);
  }

  .card-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 4px;
  }

  .card-header-text {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }

  .card-pretitle {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: ${tokens.color.text.tertiary};
  }

  .card-title {
    overflow: hidden;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: ${tokens.color.text.primary};
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .card-menu-button {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    color: ${tokens.color.text.tertiary};
    border-radius: 6px;

    :hover {
      background-color: ${tokens.color.background.light};
    }
  }

  .card-content {
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: 24px;
  }

  .card-icon {
    flex-shrink: 0;
    color: ${tokens.color.text.tertiary};
  }

  .card-text {
    flex: 1;
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    color: ${tokens.color.text.tertiary};
  }
`

export default CardEvaluativeTestsStyled
